import { findPos } from './find-pos';

export function scrollToId(id) {
  const position = findPos(document.getElementById(id));

  window.scroll(0, position);
}
